export const parseBadge = badgeData => {
  let badge = '';
  if (typeof badgeData === 'object') {
    return badgeData;
  }

  try {
    badge = JSON.parse(badgeData || null);
  } catch (e) {
    console.error('Error parsing Badge data, setting it to null', e);
    badge = null;
  }

  return badge;
};
